import React from "react"
import { Link } from "gatsby"

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer-area pt-50">
      <div className="container">
        <div className="row">
        <div className="section-title2">
          <h3>Evrchat Offices</h3>
        </div>
          <div className="col-lg-6 col-sm-6">
            <div className="single-footer-widget">
              <ul className="footer-contact-info">
                <li>
                  <i className="bx bx-map"></i> <b>United States</b> <br />
                  <p>7345, W Sand Lake Rd <br /> STE 210 – Office 3339 <br /> Orlando, FL 32819</p>
                </li>
                {/* <li>
                  <i className="bx bx-envelope"></i>
                  <a href="mailto:hello@evrchat.com">usa@evrchat.com</a>
                </li> */}
              </ul>
            </div>
          </div>

          <div className="col-lg-6 col-md-6">
            <div className="single-footer-widget">
              <ul className="footer-contact-info">
                <li>
                  <i className="bx bx-map"></i><b>Australia</b><br />
                  <p>Level 1, 191 Saint Georges Terrace <br /> Perth <br /> WA 6000</p>
                </li>
                {/* <li>
                  <i className="bx bx-phone-call"></i>
                  <a href="tel:11234567890">+61123456789</a>
                </li>
                <li>
                  <i className="bx bx-envelope"></i>
                  <a href="mailto:hello@evrchat.com">hello@evrchat.com</a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <br/>
        <div className="footer-bottom-area">
          <div className="row align-items-center">
            <div className="col-lg-4 col-md-4">
              <p>
                Copyright ⓒ 2025 Evrchat All rights reserved
              </p>
            </div>
            <div className="col-lg-4 col-md-4">
              <center>

              <Link to="/terms-of-service"><p>Terms of Use</p></Link>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                <Link to="/privacy-policy"><p>Privacy Policy</p></Link>
              
              </center>
              
            </div>

            <div className="col-lg-4 col-md-4">
              <ul>
                <li>
                  <a
                    href="https://www.linkedin.com/"
                    className="d-block"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <p><i className="bx bxl-linkedin"></i></p>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/"
                    className="d-block"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <p><i className="bx bxl-twitter"></i></p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
